import { ReactElement } from 'react';

import { TooltipName, TooltipRoot, TooltipValue } from '../styles';

interface StatesBarTooltipProps {
  name: string;
  formattedValue: string;
}

export function StatesBarTooltip({
  name,
  formattedValue,
}: Readonly<StatesBarTooltipProps>): ReactElement {
  return (
    <TooltipRoot>
      <TooltipName>{name}</TooltipName>
      <TooltipValue>{formattedValue}</TooltipValue>
    </TooltipRoot>
  );
}
